import React from 'react'
import { NotAvailable } from '@myxplor/ui'
import { customFn } from './custom-fn'
import './record-display.css'

const label = ({ label }) => <dt>{label}</dt>

const value = (record, { key, label, fn }) => {
  if (fn) {
    return customFn(record, { label, fn })
  }

  return nestedLookup(record, String(key).split('.')) || <NotAvailable key={label} name={label} />
}

export const nestedLookup = (record = {}, keys = []) => {
  const [key, ...nextKeys] = keys
  const nextRecord = record[key.trim()]

  return nextKeys.length > 0 && nextRecord
    ? nestedLookup(nextRecord, nextKeys)
    : // JSX renders booleans as empty strings :-(
    typeof nextRecord === 'boolean'
      ? String(nextRecord)
      : nextRecord
}

const RecordDisplayView = ({ keys = [], record }) => (
  <ol className="recordDisplay">
    {keys.map((key, i) => (
      <li key={i}>
        <div className="recordDisplay--item">
          {label(key)}
          <dd>{value(record, key)}</dd>
        </div>
      </li>
    ))}
  </ol>
)

export default RecordDisplayView



// WEBPACK FOOTER //
// ./src/ui/record-display/views/index.jsx